import _find from 'lodash/find';
import { setupMaster } from 'cluster';

let impotTypes = {};
let importNames = {};

/**
 * Função para interação com a input de importação
 * de despesas, com base na extensão do arquivo de
 * acordo com o tipo de importação selecionado
 */
exports.init = function ImportExpenses() {
  const inputTypeImport = document.getElementById('tipoImportacao');
  if (!document.body.contains(inputTypeImport)) {
    return;
  }

  // Pegando os tipos de exportações
  // e suas respectivas extensões
  impotTypes = JSON
    .parse(inputTypeImport.dataset.exportTypes);

  importNames = JSON
    .parse(inputTypeImport.dataset.nameLayouts);

  addListeners(inputTypeImport);
  changeTypeFileUpload(inputTypeImport);
}

/**
 * Listener de change da input de tipos de importação
 *
 * @param {Element} inputTypeImport
 */
function addListeners(inputTypeImport) {
  inputTypeImport.addEventListener('change', () => {
    changeTypeFileUpload(inputTypeImport);
  });
}

/**
 * Alterando o elemento do Filepicker que será exibido,
 * para cada tipo difrente de extensão um elemento sera
 * exibido
 *
 * @param {Element} inputTypeImport
 */
function changeTypeFileUpload(inputTypeImport) {
  const importTypeSelected = $(inputTypeImport)[0].selectize.getValue();
  const typeFileInput = document.querySelector('#typeFile');
  const extension =  impotTypes[importTypeSelected];
  const layout = importNames[importTypeSelected];
  let holderInputFile = null;

  switch (extension) {
    case 'TXT':
      holderInputFile = document.getElementById('holderTxtFile');
      typeFileInput.value = 'Txt';
      break;
    case 'EXCEL':
      holderInputFile = document.getElementById('holderExcelFile');
      typeFileInput.value = 'Excel';
      break;
    case 'RET':
      holderInputFile = document.getElementById('holderRetFile');
      typeFileInput.value = 'Ret';
      break;
    case 'XML':
      holderInputFile = document.getElementById('holderXmlFile');
      typeFileInput.value = 'Xml';
      break;
    default:
      holderInputFile = document.getElementById('holderSelectType');
      typeFileInput.value = '';
      break;
  }

  document.querySelectorAll('.holder-input-files')
    .forEach((currentHolder) => {
      currentHolder.classList.add('hidden');
    });

  if (holderInputFile === null) {
    return;
  }

  holderInputFile.classList.remove('hidden');
}
